import {useOffice} from '../../../../../../../contexts/office/context';
import {useParams, useRouteMatch} from 'react-router-dom';
import {AssociateDeviceForm} from '../../../../../../../components/associate-device-form/associate-device-form';
import {CaregiverMode} from '../../../../../../../enums/caregiver-mode';

export default function SeniorAssociateDeviceProfessionalCaregiverOfficeScreen() {
  // Get params
  let {id, entityId}: {id: string; entityId: string} = useParams();

  // Get context
  const officeContext = useOffice();

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  const userName = (officeContext.state.userForm?.user.displayName ||
    officeContext.state.userForm?.user.name)!;

  return (
    <AssociateDeviceForm
      caregiverMode={CaregiverMode.Professional}
      userId={id}
      userName={userName}
      redirectUrl={url.replace('/associate', '')}
      entityId={entityId}
    />
  );
}
